import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_COURSE_LEVEL = requestConstantsMaker('GET_ALL_COURSE_LEVEL');
export const GET_COURSE_LEVEL = requestConstantsMaker('GET_COURSE_LEVEL');
export const CREATE_COURSE_LEVEL = requestConstantsMaker('CREATE_COURSE_LEVEL');
export const UPDATE_COURSE_LEVEL = requestConstantsMaker('UPDATE_COURSE_LEVEL');
export const GET_COURSE_LEVELS_FOR_SELECTION = requestConstantsMaker('GET_COURSE_LEVELS_FOR_SELECTION');
/**** 20200217 ****/

export const GET_ALL_COURSE_LEVEL_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_COURSE_LEVEL_BY_SPECIFICATION');
export const GET_COURSE_LEVEL_BY_ID = requestConstantsMaker('GET_COURSE_LEVEL_BY_ID');
export const POST_CREATE_COURSE_LEVEL = requestConstantsMaker('POST_CREATE_COURSE_LEVEL');
export const PUT_UPDATE_COURSE_LEVEL = requestConstantsMaker('PUT_UPDATE_COURSE_LEVEL');